import React, { createContext, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

const LangContext = createContext(undefined)

export const LangProvider = ({ children }) => {
  const { i18n } = useTranslation()
  const [selectedLanguage, setSelectedLanguage] = useState('ptbr')

  const changeSelectedLanguage = (newLanguage) => {
    i18n.changeLanguage(newLanguage)
    setSelectedLanguage(newLanguage)
  }

  return (
    <LangContext.Provider value={{ selectedLanguage, changeSelectedLanguage }}>
      {children}
    </LangContext.Provider>
  )
}

export const useLangContext = () => {
  const context = useContext(LangContext)
  if (!context) {
    throw new Error('useLangContext failed')
  }
  return context
}
